import logoImg from "@/assets/logo.png";
import logoTransparentImg from "@/assets/logo-transparent.png";
import logoCrestImg from "@/assets/logo-crest.png";

export const LOGO = logoImg;
export const LOGO_TRANSPARENT = logoTransparentImg;
export const LOGO_CREST = logoCrestImg;

export const CONTACT = {
  phone: "+1 (555) 000-0000",
  email: "info@asautoworks.com",
  address: "123 Customs Blvd, Suite A, Motor City, MC 90210",
  hours: [
    { day: "Mon – Fri", time: "8:00 AM – 6:00 PM" },
    { day: "Saturday", time: "9:00 AM – 4:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
  instagram: "https://instagram.com",
  facebook: "https://facebook.com",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/94272/sports-car-pkw-auto-vehicle-94272.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  tinting: "https://images.pexels.com/photos/31154212/pexels-photo-31154212.jpeg?auto=compress&cs=tinysrgb&w=1200",
  ppf: "https://images.unsplash.com/photo-1669882571612-4a9c7822cd4c?auto=format&fit=crop&w=1200&q=80",
  vinyl: "https://images.unsplash.com/photo-1774576319912-00a4036c6333?auto=format&fit=crop&w=1200&q=80",
  ceramic: "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?auto=format&fit=crop&w=1200&q=80",
};

export const GALLERY = [
  { src: "https://images.unsplash.com/photo-1620584898989-d39f7f9ed1b7?auto=format&fit=crop&w=900&q=80", alt: "Machine polishing glossy black paint" },
  { src: "https://images.unsplash.com/photo-1774576319912-00a4036c6333?auto=format&fit=crop&w=900&q=80", alt: "Black luxury sedan with dark tint" },
  { src: "https://images.unsplash.com/photo-1708805282695-ef186db20192?auto=format&fit=crop&w=900&q=80", alt: "Interior custom work" },
  { src: "https://images.unsplash.com/photo-1708805282683-50a060eba80f?auto=format&fit=crop&w=900&q=80", alt: "Wheel and tire detailing" },
  { src: "https://images.pexels.com/photos/31154212/pexels-photo-31154212.jpeg?auto=compress&cs=tinysrgb&w=900", alt: "Applying window tint film" },
  { src: "https://images.unsplash.com/photo-1620584899131-a5ff5f8fbb03?auto=format&fit=crop&w=900&q=80", alt: "Finished interior detail" },
];

export const SERVICES = [
  {
    name: "Window Tinting",
    status: "Active",
    blurb: "Precision-cut premium films for heat rejection, UV protection, privacy and a flawless factory finish.",
    image: IMAGES.tinting,
    points: ["Ceramic & carbon films", "Lifetime warranty options", "Legal-limit & custom shades"],
  },
  {
    name: "Paint Protection Film",
    status: "Coming Soon",
    blurb: "Self-healing PPF that shields your paint from rock chips, scratches and road debris.",
    image: IMAGES.ppf,
    points: [],
  },
  {
    name: "Vinyl Wraps",
    status: "Coming Soon",
    blurb: "Full and partial color-change wraps in matte, satin, gloss and specialty finishes.",
    image: IMAGES.vinyl,
    points: [],
  },
  {
    name: "Ceramic Coatings",
    status: "Coming Soon",
    blurb: "Hydrophobic, high-gloss protection that keeps your vehicle cleaner for longer.",
    image: IMAGES.ceramic,
    points: [],
  },
];
